import * as React from "react";
import {TileTitle} from "./panels/tile-title/tile-title";
import {FileFormat} from "./panels/file-format/file-format";
import {ButtonDesign} from "./panels/button-design/button-design";

export const DownloadReport = ({tile, form, parentTile, tileAction, isContainerTile}) =>
    [TileTitle, FileFormat, ButtonDesign].map((panel) => panel({tile, form, parentTile, tileAction, isContainerTile}));
